import React, { useMemo, useCallback } from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { injectIntl, defineMessages } from 'react-intl';
import { useDispatch } from 'react-redux';
import SettingDropdown from './SettingDropdown';
import { getDevicesByKind } from 'utils/deviceUtils';
import { toggleAudioTest } from 'actions/AvSettingsModal';
import DropdownLabel from 'components/Dropdown/DropdownLabel';

interface Props {
  intl: { formatMessage: Function };
  wide?: boolean;
  isJoinFlowCall?: boolean;
  handleConfigChange: Function;
}

const messages = defineMessages({
  inputMicrophone: { id: 'components.avSettings.inputLabel.Microphone', defaultMessage: 'Microphone' },
  inputMicrophoneSelect: {
    id: 'components.avSettings.inputLabel.MicrophoneSelect',
    defaultMessage: 'Select your microphone'
  }
});

export const MicrophoneDropdown = (props: Props) => {
  const { intl, isJoinFlowCall, handleConfigChange, wide } = props;
  const devices = hooks.useDevices();
  const { audioDevice } = hooks.useMedia();
  const dispatch = useDispatch();
  const audioInputDevices = useMemo(() => getDevicesByKind(devices, 'audioinput'), [devices]);

  const getDeviceValue = useCallback(() => {
    const selectedDevice =
      audioInputDevices.find((device) => device.value === audioDevice?.deviceId) || audioInputDevices?.[0];
    return selectedDevice?.value;
  }, [audioInputDevices, audioDevice]);

  return (
    <section>
      <DropdownLabel
        error={!(audioInputDevices?.length > 0)}
        label={intl.formatMessage(isJoinFlowCall ? messages.inputMicrophoneSelect : messages.inputMicrophone)}
        dataTestId={'microphoneSelectionHeader'}
      />
      <SettingDropdown
        handleChange={(value) => {
          dispatch(toggleAudioTest(false));
          handleConfigChange('microphone', value);
        }}
        items={audioInputDevices}
        label={intl.formatMessage(messages.inputMicrophone)}
        testIdPrefix="microphone"
        value={getDeviceValue()}
        wide={wide}
      />
    </section>
  );
};

export default injectIntl(MicrophoneDropdown);
